import { render, staticRenderFns } from "./login-precifique-code.view.html?vue&type=template&id=a4532132&"
import script from "./login-precifique-code.vue?vue&type=script&lang=ts&"
export * from "./login-precifique-code.vue?vue&type=script&lang=ts&"
import style0 from "./login-precifique-code.view.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports